import { ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues } from '@omegagrid/form';
import rp, { formatDateTime } from '@reporting/rp-app-host';
import { StatementDefinition } from '@reporting/rp-types/definition';

export type FinExportType = 'trialBalance' | 'accountDefinition' | 'definition';

const FinExportTypeList: Record<FinExportType, string> = {
	trialBalance: 'Trial Balance',
	accountDefinition: 'Account Definition',
	definition: 'Complete Definition'
};

export class FinExportFormAdapter extends FormAdapter {

	constructor(
		private statement: StatementDefinition
	) { super() }

	getColumns() {
		return [
			{ width: 80 },
			{ width: null },
		];
	}

	async getControls() {
		const years = await rp.ms('analytics').get<number[]>('years/all', { accounting: this.statement.accounting });
		return [
			{ row: 0, col: 0, type: FormControlType.Label, value: msg('Type'), for: 'exportType' },
			{ row: 0, col: 1, type: FormControlType.List, key: 'exportType', required: true, value: 'trialBalance', content: {
				sourceData: Object.entries(FinExportTypeList).map(([k, v]) => ({ k, v: msg(v) })),
				options: { selectMode: 'single', autoClose: true }
			}},
			{ row: 1, col: 0, type: FormControlType.Label, value: msg('Year'), for: 'year' },
			{ row: 1, col: 1, type: FormControlType.List, key: 'year', required: true, value: new Date().getFullYear(), content: {
				sourceData: years.map(year => ({ k: year, v: year })),
				options: { selectMode: 'single', autoClose: true }
			}},
		];
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: [{ key: "save", text: msg("Export"), color: ColorTypes.Blue }, "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const { year, exportType } = values.get(0);
		const label = msg(FinExportTypeList[exportType as FinExportType]);
		const dateTime = formatDateTime(new Date(), 'yyyyMMddHHmmss');
		const name = `${this.statement.statement}_${label}_${year}_${dateTime}`;

		if (exportType === 'definition') {
			// the re-importable document served to the AI tools (get_statement_definition / define_statement);
			// the year selects the account assignments included
			await rp.ms('definition').download(`statements/${this.statement.id_statement}/definition`, { year, fileName: `${name}.json` });
			return true;
		}

		await rp.ms('definition').download(`statements/${this.statement.id_statement}/export/${exportType}`, { year, fileName: `${name}.xlsx` });
		return true;
	}

};
